(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["assembly-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var accordions = document.getElementsByClassName("accordion");
    
  for (var i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener("click", function() {
      var panel = this.nextElementSibling;
      // Toggle active class
      this.classList.toggle("active");

      // Check and switch display style accordingly
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-buttons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.image-button');

    buttons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const blockId = this.getAttribute('href');
            document.querySelector(blockId).scrollIntoView({ 
                behavior: 'smooth' 
            });
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom-blocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Kapsayıcı accordion işlevselliği
  var containerAccordions = document.getElementsByClassName("container-accordion");

  for (var i = 0; i < containerAccordions.length; i++) {
    containerAccordions[i].querySelector(".container-header").addEventListener("click", function() {
      this.parentElement.classList.toggle("active");
    });
  }

  // İç accordion işlevselliği
  var accordions = document.getElementsByClassName("s-accordion");

  for (var i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener("click", function() {
      var panel = this.nextElementSibling;
      this.classList.toggle("active");

      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }

  // Telefon paneli işlevselliği
  document.querySelectorAll("[id^='phone-text']").forEach(function(callText) {
    const blockId = callText.dataset.blockId;
    const callArea = document.getElementById(`call-selection-${blockId}`);
    const closeAreaBtn = document.getElementById(`close-area-btn-${blockId}`);

    callText.addEventListener('click', function (e) {
      e.preventDefault();
      callArea.style.display = callArea.style.display === 'none' ? 'flex' : 'none';
      const rect = callText.getBoundingClientRect();
      callArea.style.top = `${rect.bottom + window.scrollY}px`;
      callArea.style.left = `${rect.left + window.scrollX}px`;
    });

    closeAreaBtn.addEventListener('click', function () {
      callArea.style.display = 'none';
    });

    document.addEventListener('click', function (e) {
      if (!callText.contains(e.target) && !callArea.contains(e.target)) {
        callArea.style.display = 'none';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
